import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const adrMonitoringService = {
    list: async (body = {}, params = {}) => axios.post(API_KEEPER + "/fact/monitoring/search/", body, { params }).then(({ data }) => data).catch((err) => { throw err }),
    create: async (payload) => axios.post(API_KEEPER + "/fact/monitoring/create", payload).then(({ data }) => data).catch((err) => { throw err }),
    update: async (id, payload) => axios.put(API_KEEPER + `/fact/monitoring/${id}`, payload).then(({ data }) => data).catch((err) => { throw err }),
    remove: async (id) => axios.delete(API_KEEPER + `/fact/monitoring/${id}`).then(({ data }) => data).catch((err) => { throw err }),
    get: async (id) => axios.get(API_KEEPER + `/fact/monitoring/by-id/${id}`).then(({ data }) => data).catch((err) => { throw err }),
}

export default adrMonitoringService;